export interface CardItem {
  id: string;
  name: string;
  category: string;
  subCategory: string;
  description: string;
  isStarred: boolean;
  type: 'api' | 'data';
}

export const API_CATEGORIES = [
  { id: 'patent', name: '专利', items: ['专利检索', '基本数据', '引用与回溯', '法律状态与交易', '专利价值评价', '技术分析与提炼', '技术与分类查询'] },
  { id: 'trademark', name: '商标', items: ['商标检索', '商标基本信息'] },
  { id: 'enterprise', name: '企业', items: ['企业检索', '企业基本信息'] },
  { id: 'agency', name: '代理机构', items: ['检索与基本信息', '数据统计与分析'] },
  { id: 'analysis', name: '统计分析', items: ['技术全景分析', '企业分析', '智能分析报告'] },
  { id: 'copyright', name: '版权', items: ['版权检索'] },
  { id: 'standard', name: '标准', items: ['标准检索'] },
];

export const DATA_CATEGORIES = [
  { id: 'basic', name: '基础数据', items: ['专项特新', '企业画像'] },
];

export const INITIAL_CARDS: CardItem[] = [
  { id: '1', name: '简单检索', category: 'patent', subCategory: '专利检索', description: '输入专利公开号即可获取对应的专利列表信息，包括专利名称、申请人和公开日期等基本事项。', isStarred: true, type: 'api' },
  { id: '2', name: '高级检索', category: 'patent', subCategory: '专利检索', description: '输入多维度信息，不限于专利名称、申请人和公开日期等条件进行检索。', isStarred: false, type: 'api' },
  { id: '3', name: '指令检索', category: 'patent', subCategory: '专利检索', description: '专业检索工具，通过输入指令检索式进行检索。', isStarred: false, type: 'api' },
  { id: '4', name: '批量号码检索', category: 'patent', subCategory: '专利检索', description: '批量申请号或公开号检索专利列表，高效处理大批量号码查询，节省时间和人力。', isStarred: false, type: 'api' },
  { id: '5', name: '批量申请人检索', category: 'patent', subCategory: '专利检索', description: '批量申请人或当前权利人检索专利列表，快速掌握特定主体的专利布局。', isStarred: false, type: 'api' },
  { id: '6', name: '相似专利检索', category: 'patent', subCategory: '专利检索', description: '查找与指定专利相似的专利，按照相似度排序，帮助用户发现潜在的竞争对手或技术发展方向。', isStarred: false, type: 'api' },
  { id: '7', name: '企业关键词检索', category: 'enterprise', subCategory: '企业检索', description: '输入组织名称/统一社会信用代码/法人姓名查询企业信息，轻松获取企业关键信息，助力市场调研。', isStarred: true, type: 'api' },
  { id: '8', name: '企业基本信息', category: 'enterprise', subCategory: '企业基本信息', description: '查询工商注册资料，快速掌握企业注册资本、法人代表等核心信息，便于决策分析。', isStarred: true, type: 'api' },
  { id: '9', name: '企业经营状态', category: 'enterprise', subCategory: '企业检索', description: '查询企业经营状态，监控企业运营状况，判断企业发展趋势，为合作伙伴选择提供依据。', isStarred: true, type: 'api' },
  { id: '10', name: '企业属性标签', category: 'enterprise', subCategory: '企业基本信息', description: '查询企业标签情况，快速识别企业所属行业、规模等属性，便于进行市场细分和行业分析。', isStarred: true, type: 'api' },
  { id: '11', name: '企业合作关系', category: 'enterprise', subCategory: '企业检索', description: '查询企业合作过的企业、学校、研究院、医院等组织，揭示企业合作伙伴网络，洞察行业合作态势。', isStarred: true, type: 'api' },
  { id: '5', name: '专项特新“小巨人”', category: 'basic', subCategory: '专项特新', description: '精准覆盖2023与2024年北京市第五、六批国家级专精特新“小巨人”企业。', isStarred: false, type: 'data' },
];

export const USAGE_STATS = {
  total: 40,
  topItems: [
    { name: '企业关键词检索', count: 9 },
    { name: '企业合作关系', count: 4 },
    { name: '企业基本信息', count: 4 },
    { name: '企业经营状态', count: 3 },
  ]
};
